import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgWarning = function SvgWarning(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.377 16.986L15.456 3.064c-1.547-2.671-5.391-2.671-6.938 0L.596 16.986c-1.5 2.672.422 5.953 3.469 5.953h15.89c3.047 0 4.97-3.328 3.422-5.953zm-12.375-9a.99.99 0 01.985-.984c.515 0 .984.469.984.984v6a.99.99 0 01-.984.985c-.516 0-.985-.469-.985-.985v-6zm.985 11.438a1.46 1.46 0 01-1.453-1.453 1.46 1.46 0 011.453-1.453 1.46 1.46 0 011.453 1.453 1.46 1.46 0 01-1.453 1.453z"
  }));
};

export default SvgWarning;